import { Component, OnInit, ViewEncapsulation, Input, OnChanges } from '@angular/core';
import * as Chartist from 'chartist';
import * as moment from 'moment';
import { AccountEvolution } from '../models/account-evolution';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { TweenMax } from 'gsap';

@Component({
	selector: 'app-account-evolution',
	templateUrl: './account-evolution.component.html',
	styleUrls: ['./account-evolution.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class AccountEvolutionComponent implements OnInit, OnChanges {

	@Input() accountEvolution: AccountEvolution = new AccountEvolution();
	@Input() evolutionDate: any;

	constructor() { }

	ngOnInit() {
	}

	ngOnChanges() {
		this.evolutionDate = moment(new Date().setDate(new Date().getDate())).locale('pt-BR');
		this.evolutionDate = moment(this.evolutionDate).format('MMMM/YYYY');


		if (this.accountEvolution) {
			if (this.accountEvolution.labels.length > 0) {
				const finalTick = this.accountEvolution.ticks[this.accountEvolution.ticks.length - 1];
				const chart = new Chartist.Line('.evolution-chart', {
					labels: this.accountEvolution.labels,
					series: [
						this.accountEvolution.values
					]
				}, {
					fullWidth: true,
					axisY: {
						type: Chartist.FixedScaleAxis,
						ticks: [finalTick],
						offset: 80,
						labelInterpolationFnc: function(value) {
							return 'R$ ' + value.toLocaleString('pt-BR');
						}
					}
				});
			} else {
				const chart = new Chartist.Line('.evolution-chart', {
					labels: [0],
					series: [
						[0]
					]
				}, {
					fullWidth: true,
					axisY: {
						type: Chartist.FixedScaleAxis,
						ticks: [0]
					}
				});
			}
		}

		TweenMax.delayedCall(3, () => {
			if (this.accountEvolution) {
				if (this.accountEvolution.labels.length > 0) {
					const finalTick = this.accountEvolution.ticks[this.accountEvolution.ticks.length - 1];
					const chart = new Chartist.Line('.evolution-chart-to-print', {
						labels: this.accountEvolution.labels,
						series: [
							this.accountEvolution.values
						]
					}, {
						fullWidth: true,
						axisY: {
							type: Chartist.FixedScaleAxis,
							ticks: [finalTick],
							offset: 80,
							labelInterpolationFnc: function(value) {
								return 'R$ ' + value.toLocaleString('pt-BR');
							}
						}
					});
				} else {
					const chart = new Chartist.Line('.evolution-chart-to-print', {
						labels: [0],
						series: [
							[0]
						]
					}, {
						fullWidth: true,
						axisY: {
							type: Chartist.FixedScaleAxis,
							ticks: [0]
						}
					});
				}
			}
		});

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/dashboard/account-evolution/account-evolution.component.ts